<div class="pagination-container">
    <ul class="pagination">
        <li (click)="selectPage(currentPage - 1, $event)" [class.disabled]="currentPage == 1" id="previousPage">
            <a href="" title="Go to previous page">&lsaquo;</a>
        </li>
        <li (click)="selectPage(1, $event)" [class.active]="currentPage == 1" id="firstPage">
            <a href="" title="Go to first page">1</a>
        </li>
        <li class="disabled" (click)="cancelEvent($event)" *ngIf="(currentPage - range) > 1" id="moreNext">
            <a href="">...</a>
        </li>
        <li *ngFor="let page of (pages | async); let i = index" [class.active]="page == currentPage">
            <a href="" (click)="selectPage(page, $event)" id="page{{i + 1}}" *ngIf="page != totalPages && i != 0">
                {{page}}
            </a>
        </li>
        <li class="disabled" (click)="cancelEvent($event)" *ngIf="(currentPage + range) < totalPages" id="morePrevious">
            <a href="">...</a>
        </li>
        <li (click)="selectPage(totalPages, $event)" [class.active]="currentPage == totalPages" id="lastPage">
            <a href="" title="Go to last page" id="pageLink{{totalPages}}">{{totalPages}}</a>
        </li>
        <li (click)="selectPage(currentPage + 1, $event)" [class.disabled]="currentPage == totalPages" id="nextPage">
            <a href="" title="Go to next page">&rsaquo;</a>
        </li>
    </ul>
</div>